import { GREENER_CHOICES } from '@web-platform/shared-universal-constants/src/queryParams';
import { booleanParamParser } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';

import { INITIAL_STATE } from '../eco';

import type { EcoFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/eco';

export const getEcoFromUrl = (): EcoFilterState => {
  const checked = booleanParamParser.deserialize(parseParams()[GREENER_CHOICES]) === true;

  return checked ? { checked: true } : INITIAL_STATE;
};
